import {BaseModel} from "../base.model";

export interface DirectAscent extends BaseModel {
    
}
export const defaultDirectAscent:  Readonly<DirectAscent> = {};